import { TOperationExtensions } from '@rbx/docsite-utilities';
import { OpenAPIV3 } from 'openapi-types';

export enum OpenCloudAPIObjectReferenceType {
  Schema = 'Schema',
  // add more from "Components Object" in OAS
}

// only v3 spec should be considered as it's guaranteed by BE
export { OpenAPIV3 as OpenAPI };
export type HttpMethods = OpenAPIV3.HttpMethods;
export type Schema = OpenAPIV3.SchemaObject;
export type Parameter = OpenAPIV3.ParameterObject;
export type ResponseObject = OpenAPIV3.ResponseObject;
// ignore all reference object, as it should've been inlined by the parser
export type SchemaReferenceMap = Map<Schema, string>;
export type SchemaObjectType = OpenAPIV3.NonArraySchemaObjectType | OpenAPIV3.ArraySchemaObjectType;
export type SecurityRequirementObject = OpenAPIV3.SecurityRequirementObject;

export interface OpenCloudAPIExtensionFields {
  'x-roblox-cloud-api-operation-name'?: string;
  'x-roblox-cloud-api-operation'?: boolean;
  'x-roblox-cloud-api-operation-code-samples'?: OpenCloudAPICodeSample[];
  'x-roblox-rate-limits'?: TOperationExtensions['x-roblox-rate-limits'];
}

export interface OpenCloudAPIObjectReference {
  refType: OpenCloudAPIObjectReferenceType;
  name: string;
  required: boolean;
}

// TODO: check where 'example' belongs
export type OpenCloudAPISchema = { example?: string } & (
  | OpenCloudAPIObjectReference
  | OpenCloudAPIArraySchema
  | OpenCloudAPINonArraySchema
  | null
);

export interface OpenCloudAPIArraySchema extends Omit<OpenAPIV3.ArraySchemaObject, 'items'> {
  items: OpenCloudAPISchema;
}

export interface OpenCloudAPIObjectSchemaProperties {
  [name: string]: NonNullable<OpenCloudAPISchema>;
}

export interface OpenCloudAPINonArraySchema
  extends Omit<OpenAPIV3.NonArraySchemaObject, 'properties'> {
  properties?: OpenCloudAPIObjectSchemaProperties;
}

export interface OpenCloudAPIObjectSchema extends Omit<OpenAPIV3.SchemaObject, 'properties'> {
  properties?: OpenCloudAPIObjectSchemaProperties;
}

export interface OpenCloudAPIMediaType extends Omit<OpenAPIV3.MediaTypeObject, 'schema'> {
  schema: OpenCloudAPISchema;
}

export interface OpenCloudAPIRequestBody extends Omit<OpenAPIV3.RequestBodyObject, 'content'> {
  content: { [media: string]: OpenCloudAPIMediaType };
}

export interface OpenCloudAPIParameter extends Omit<OpenAPIV3.ParameterObject, 'schema'> {
  schema: OpenCloudAPISchema & { example?: string };
  // TODO: check where 'example' belongs;
}

export interface OpenCloudAPIResponseObject extends Omit<OpenAPIV3.ResponseObject, 'content'> {
  content?: { [media: string]: OpenCloudAPIMediaType };
}

export interface OpenCloudAPIPathsParams {
  name: string;
  version: string;
}

export interface OpenCloudAPICodeSample {
  language: string;
  script: string;
}
